import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { PlayButtonWrapper as CompiledPlayButtonWrapper } from './playButtonWrapper-compiled';
import { PlayButtonWrapper as EmotionPlayButtonWrapper } from './playButtonWrapper-emotion';
export var PlayButtonWrapper = function PlayButtonWrapper(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledPlayButtonWrapper, props) : /*#__PURE__*/React.createElement(EmotionPlayButtonWrapper, props);
};